// @ts-nocheck
// const API_URL = "http://127.0.0.1:3000/api";
const API_URL = "https://shopify.runmefitserver.com/api"

const stepsInfo = [
  {
    title: "First, who is this Runmefit device for?",
    options: [
      {
        label: "Him",
        value: "Male",
        image: "https://cdn.shopify.com/s/files/1/0632/9067/1266/files/frame_2085662333_2.webp?v=1769392210&width=1280",
      },
      {
        label: "Her",
        value: "Female",
        image: "https://cdn.shopify.com/s/files/1/0632/9067/1266/files/frame_2085662333_2.webp?v=1769392210&width=1280",
      }
    ]
  },
  {
    title: "What is the main reason for buying this watch?",
    options: [
      {
        label: "Knowing My Body and Health",
        image: "https://cdn.shopify.com/s/files/1/0632/9067/1266/files/frame_2085662334_2.webp?v=1769392211&width=1280",
      },
      {
        label: "Running and Training",
        image: "https://cdn.shopify.com/s/files/1/0632/9067/1266/files/frame_2085662334_2.webp?v=1769392211&width=1280",
      },
      {
        label: "Exploring the Wild",
        image: "https://cdn.shopify.com/s/files/1/0632/9067/1266/files/frame_2085662334_2.webp?v=1769392211&width=1280",
      },
      {
        label: "Staying Connected & Productive",
        image: "https://cdn.shopify.com/s/files/1/0632/9067/1266/files/frame_2085662334_2.webp?v=1769392211&width=1280",
      }
    ]
  },
  {
    title: "Which style do you prefer on the wrist?",
    options: [
      {
        label: "Classic Round",
        value: "Classic Round",
        image: "https://cdn.shopify.com/s/files/1/0632/9067/1266/files/frame_2085662336.webp?v=1769161499&width=1280",
      },
      {
        label: "Modern Square",
        value: "Modern Square",
        image: "https://cdn.shopify.com/s/files/1/0632/9067/1266/files/frame_2085662336.webp?v=1769161499&width=1280",
      },
      {
        label: "Slim Band",
        value: "Slim Band",
        image: "https://cdn.shopify.com/s/files/1/0632/9067/1266/files/frame_2085662336.webp?v=1769161499&width=1280",
      }
    ]
  },
  {
    title: "Which of these matters most to you right now?",
    isMultiple: true,
    background: "https://cdn.shopify.com/s/files/1/0632/9067/1266/files/frame_2085662337_2.webp?v=1769392210&width=1280",
    options: [
      {
        label: "Better Sleep",
      },
      {
        label: "Longer Battery",
      },
      {
        label: "Workout Motivation",
      },
      {
        label: "Less Stress",
      },
      {
        label: "Pedometer",
      },
      {
        label: "Breath and Meditate"
      }
    ]
  }
]

let sessionId = ""
// 全局
let flowStarted = false;
let flowCompleted = false;

// 总活跃时间
let totalActiveTime = 0;
let totalLastVisibleTs = performance.now();

let stepActiveTime = 0;
let stepLastVisibleTs = performance.now();

// 每段的记录
let stepSegments = [];


async function getSession() {
  return new Promise(async (resolve) => {
    const storageSessionId = sessionStorage.getItem("sessionId")
    if (storageSessionId) {
      sessionId = storageSessionId;
      resolve(sessionId);
      return;
    }
    const response = await fetch(API_URL + "/hmc/create-session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        startTime: new Date()
      }),
    });
    const result = await response.json();
    sessionId = result.data;
    sessionStorage.setItem("sessionId", result.data)
    resolve(result.data);
  })
}

// 发送放弃或最终步骤数据（使用 updateSession API）
function sendAbandonOrFinalStep(data) {
  if (!sessionId) return;

  const payload = {
    sessionId: sessionId,
    isCompleted: flowCompleted,
    totalDuration: data.totalActiveTime,
    finalStep: data.currentStep
  };

  // 使用 sendBeacon 确保在页面卸载时也能发送数据
  const blob = new Blob([JSON.stringify(payload)], {
    type: 'application/json'
  });
  
  const success = navigator.sendBeacon(
    API_URL + "/hmc/update-session",
    blob
  );
  sessionStorage.removeItem("sessionId");
  sessionId = "";
}

document.addEventListener('visibilitychange', () => {
  if (!flowStarted) return;

  if (document.visibilityState === 'hidden') {
    const now = performance.now();

    // 总活跃时间累加
    totalActiveTime += now - totalLastVisibleTs;

    // 当前 step 累加
    stepActiveTime += now - stepLastVisibleTs;

    // 保存当前段
    stepSegments.push({ start: stepLastVisibleTs, end: now });

  } else if (document.visibilityState === 'visible') {
    const now = performance.now();
    totalLastVisibleTs = now;
    stepLastVisibleTs = now;

    // 开启新段
    stepSegments.push({ start: now });
  }
});
window.addEventListener('pagehide', () => {
  if (!flowStarted) return;

  const now = performance.now();

  // 总时间累加最后一段
  if (document.visibilityState === 'visible') {
    totalActiveTime += now - totalLastVisibleTs;
    stepActiveTime += now - stepLastVisibleTs;

    // 补最后一段（确保有段存在）
    if (stepSegments.length > 0 && stepSegments[stepSegments.length - 1]) {
      stepSegments[stepSegments.length - 1].end = now;
    }
  }

  // 获取当前步骤（从 Alpine 组件或全局变量）
  let currentStepValue = 0;
  try {
    const quizComponent = window.Alpine?.$data(document.querySelector('[x-data="quiz"]'));
    if (quizComponent) {
      currentStepValue = quizComponent.currentStep || 0;
    }
  } catch (e) {
    // 如果无法获取，使用默认值 0
    console.warn('无法获取 currentStep，使用默认值 0', e);
  }

  // 上报 abandon 或 total / step 数据
  sendAbandonOrFinalStep({
    totalActiveTime,
    currentStep: currentStepValue,
    stepActiveTime,
    stepSegments,
  });
});

// 初始化 Alpine.js 组件
document.addEventListener("alpine:init", () => {
  const Alpine = window.Alpine;
  Alpine.data("quiz", () => ({
    totalSteps: stepsInfo.length + 1, // stepsInfo 长度 + 结果页
    currentStep: 0,
    isLoading: false,
    resultProducts: [],
    stepsInfo,
    selectedOptions: [],
    matchResult: {
      resultProducts: [],
      answerCountsSum: 0,
    },
    answer: {
      gender: "",
      watchStyle: "",
      usageScenario: "",
      preferredFeature: []
    }, // 动态答案对象
    // Swiper 实例存储
    swiperInstances: {},
    // 桌面端按钮状态
    activeSliderIndex: {},

    init() {
      // 初始化 activeSliderIndex
      this.stepsInfo.forEach((step, index) => {
        this.activeSliderIndex[`step${index + 1}`] = -1;
      });
      this.updateProgressBar();
      this.updatePreviousButton();
      this.$nextTick(() => {
        this.initSwiper();
        this.initDesktopSlider();
      });
    },
    handleSeeMoreDetails(product) {
      this.insertConversion(product.title);
      window.location.href = product.url;
    },
    async insertConversion(productTitle) {
      if (!sessionId) return;
      
      const payload = {
        sessionId: sessionId,
        productName: productTitle,
      };
      
      const blob = new Blob([JSON.stringify(payload)], {
        type: 'application/json'
      });
      
      const success = navigator.sendBeacon(
        API_URL + "/hmc/insert-conversion",
        blob
      );
      
      if (!success) {
        // 如果 sendBeacon 失败，尝试使用 fetch
        fetch(API_URL + "/hmc/insert-conversion", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
          keepalive: true
        }).catch(err => {
          console.warn('插入转化数据失败:', err);
        });
      }
    },
    async createStepLog(selectedOptions, dwellTime = 0) {
      return new Promise(async (resolve) => {
        const data = {
          sessionId: sessionId,
          step: this.currentStep,
          selectedOptions: selectedOptions,
          dwellTime: parseInt(dwellTime.toFixed(0)),
        }
        const response = await fetch(API_URL + "/hmc/create-step-log", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        const result = await response.json();
        resolve(result);
      })
    },

    // 计算进度百分比
    calculateProgress(step) {
      if (step === 0) return 0;
      return (step / this.totalSteps) * 100;
    },

    // 更新进度条
    updateProgressBar(isResult = false) {
      if (isResult) {
        this.$refs.progressBar.style.display = "none";
        return;
      }
      const progress = this.calculateProgress(this.currentStep);
      this.$refs.progressBar.style.setProperty("--progress", `${progress}%`);
    },

    // 更新返回按钮显示状态
    updatePreviousButton(isResult = false) {
      if (isResult) {
        this.$refs.previousButton.style.display = "none";
        return;
      }
      if (this.currentStep === 0) {
        this.$refs.progressBar.style.display = "none";
        this.$refs.previousButton.style.display = "none";
      } else {
        this.$refs.progressBar.style.display = "block";
        this.$refs.previousButton.style.display = "block";
      }
    },

    // 显示/隐藏加载状态
    showLoading() {
      this.isLoading = true;
    },

    hideLoading() {
      this.isLoading = false;
    },

    // 模拟加载
    async fakeLoading(callback, delayOrPromise = 1000) {
      this.showLoading();

      let delay = 500;

      // 如果传入的是 Promise，等待它完成并根据耗时计算延迟
      if (delayOrPromise instanceof Promise) {
        const startTime = Date.now();
        await delayOrPromise;
        const elapsedTime = Date.now() - startTime;
        // 如果耗时小于1秒，使用1秒；否则使用实际耗时
        delay = elapsedTime < 500 ? 500 : elapsedTime;
      } else {
        // 如果传入的是数字，直接使用
        delay = delayOrPromise;
      }

      setTimeout(() => {
        callback();
        this.hideLoading();
      }, delay);
    },
    async getStepDwellTime() {
      const now = performance.now();

      // 当前 step 补最后一段
      stepActiveTime += now - stepLastVisibleTs;
      if (stepSegments.length > 0 && stepSegments[stepSegments.length - 1]) {
        stepSegments[stepSegments.length - 1].end = now;
      }

      // 根据当前步骤从 answer 中获取对应的选项值
      let selectedOptionsForLog = [];
      const stepIndex = this.currentStep - 1;
      
      if (stepIndex === 0 && this.answer.gender) {
        selectedOptionsForLog = [this.answer.gender];
      } else if (stepIndex === 1 && this.answer.usageScenario) {
        selectedOptionsForLog = [this.answer.usageScenario];
      } else if (stepIndex === 2 && this.answer.watchStyle) {
        selectedOptionsForLog = [this.answer.watchStyle];
      } else if (stepIndex === 3 && this.answer.preferredFeature) {
        selectedOptionsForLog = [...this.answer.preferredFeature];
      } else {
        // 如果从 answer 中获取不到，使用 selectedOptions 作为备选
        selectedOptionsForLog = this.selectedOptions || [];
      }

      await this.createStepLog(selectedOptionsForLog, stepActiveTime);
    },

    // 重置步骤计时器（在 scrollToStep 完成后调用）
    resetStepTimer() {
      const now = performance.now();
      stepActiveTime = 0;
      stepLastVisibleTs = now;
      stepSegments = [{ start: now }];
    },

    // 滚动到指定步骤
    scrollToStep(step, isResult = false) {
      if (isResult) {
        this.scrollToResultText();
        return Promise.resolve();
      }

      const stepElement = document.getElementById(`content-step-${step}`);
      if (!stepElement) return Promise.resolve();

      const targetScrollTop = stepElement.offsetTop;

      return new Promise((resolve) => {
        window.gsap.to(this.$refs.contentWrapper, {
          y: -targetScrollTop,
          duration: 1,
          ease: "back.out(1)",
          onComplete: () => {
            // 滚动动画完成后，重置计时器开始计时新步骤
            this.resetStepTimer();
            resolve();
          }
        });

        this.updateProgressBar(isResult);
        this.updatePreviousButton(isResult);
      });
    },

    // 滚动到结果文本
    async scrollToResultText() {
      const scrollTop = this.$refs.resultStep.offsetTop;
      window.gsap.to(this.$refs.contentWrapper, {
        y: -scrollTop,
        duration: 0.9,
        ease: "back.out(1)",
      });
      this.updateProgressBar(true);
      this.updatePreviousButton(true);

      setTimeout(async () => {
        this.$refs.resultProgressBar.classList.add("active");

        // 根据答案动态生成结果文本
        let resultText = "Based on your preferences, we've found your perfect match.";
        const answerParts = [];

        if (this.answer.gender) {
          answerParts.push(`<span class="text-[#FA590E]">${this.answer.gender}</span>`);
        }
        if (this.answer.usageScenario) {
          answerParts.push(`<span class="text-[#FA590E]">${this.answer.usageScenario}</span>`);
        }
        if (this.answer.watchStyle) {
          answerParts.push(`<span class="text-[#FA590E]">${this.answer.watchStyle}</span>`);
        }

        if (answerParts.length > 0) {
          resultText = `For your ${answerParts.join(", ")} preferences, this is your perfect match.`;
        }

        this.$refs.resultText.innerHTML = resultText;

        this.initTypewriter("result-text");

        const resultPromise = this.getQuizResult();
        const updateSessionPromise = this.updateSession();


        const minPromise = this.wait(3000);
        await Promise.all([resultPromise, updateSessionPromise, minPromise]);
        this.scrollToResult();
      }, 200);
    },
    async updateSession() {
      return new Promise(async (resolve) => {
        // 更新总活跃时间
        const now = performance.now();
        if (document.visibilityState === 'visible') {
          totalActiveTime += now - totalLastVisibleTs;
        }
        
        flowCompleted = true;
        const response = await fetch(API_URL + "/hmc/update-session", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sessionId: sessionId,
            isCompleted: true,
            totalDuration: totalActiveTime,
            finalStep: this.currentStep
          }),
        });
        const result = await response.json();
        resolve(result);
      });
    },

    // 滚动到结果页面
    scrollToResult() {
      this.$refs.scrollContainer.classList.remove("scroll")
      const offsetTop = this.$refs.contentResult.offsetTop;
      window.gsap.to(this.$refs.contentWrapper, {
        y: -offsetTop,
        duration: 0.9,
        ease: "back.out(1)",
      });
    },

    // 打字机效果
    initTypewriter(elementId, speed = 20) {
      const container = document.getElementById(elementId);
      if (!container) return;

      const originalNodes = Array.from(container.childNodes);
      container.innerHTML = "";

      async function typeNode(node, parent) {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          for (let i = 0; i < text.length; i++) {
            parent.appendChild(document.createTextNode(text[i]));
            await new Promise((resolve) => setTimeout(resolve, speed));
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const clone = node.cloneNode(false);
          clone.innerHTML = "";
          parent.appendChild(clone);

          const childNodes = Array.from(node.childNodes);
          for (const child of childNodes) {
            await typeNode(child, clone);
          }
        }
      }

      (async () => {
        for (const node of originalNodes) {
          await typeNode(node, container);
        }
      })();
    },

    async getQuizResult() {
      return new Promise(async (resolve) => {
        const response = await fetch(API_URL + "/product/get-quiz-product", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            answer: this.answer
          }),
        });
        const result = await response.json();
        this.renderResults(result);
        resolve(result);
      })
    },

    // 重置答案
    resetAnswer() {
      this.matchResult = {
        resultProducts: [],
        answerCountsSum: 0,
      }
      this.$refs.resultProgressBar.classList.remove("active");
      this.answer = {
        gender: "",
        watchStyle: "",
        usageScenario: "",
        preferredFeature: []
      };
      this.selectedOptions = [];
      this.currentStep = 0;
      // 重置所有步骤的 activeSliderIndex
      this.stepsInfo.forEach((step, index) => {
        this.activeSliderIndex[`step${index + 1}`] = -1;
      });
      this.$refs.scrollContainer.classList.add("scroll");
      setTimeout(() => {
        sessionStorage.removeItem("sessionId");
        sessionId = "";
        this.scrollToStep(this.currentStep).then(() => {
          this.updateProgressBar(false);
          this.updatePreviousButton(false);
        });
      }, 100);
    },

    // 开始按钮
    async handleStart() {
      const promise = getSession();
      flowStarted = true;
      // 初始化总时间追踪
      const now = performance.now();
      totalLastVisibleTs = now;
      // 步骤计时器将在 scrollToStep 完成后重置
      
      this.fakeLoading(async () => {
        this.currentStep = 1;
        await this.scrollToStep(this.currentStep);
      }, promise);
    },

    // 返回按钮
    handlePrevious() {
      if (this.currentStep > 0) {
        this.fakeLoading(async () => {
          this.currentStep--;
          await this.scrollToStep(this.currentStep);
        });
      }
    },

    // 继续按钮
    handleContinue() {
      // 在继续前，记录当前步骤的日志（适用于移动端和桌面端）
      const stepIndex = this.currentStep - 1;
      
      // 构建步骤日志的 Promise（如果需要记录）
      let stepLogPromise = Promise.resolve();
      
      // 多选步骤（最后一步）
      if (stepIndex === 3 && this.answer.preferredFeature && this.answer.preferredFeature.length > 0) {
        stepLogPromise = this.getStepDwellTime();
      } 
      // 单选步骤（移动端使用，桌面端已经在 handleStepClick 中记录过了）
      else if (stepIndex >= 0 && stepIndex < 3) {
        // 检查是否有选择选项（移动端可能使用 handleStepSelectOnly）
        if ((stepIndex === 0 && this.answer.gender) ||
            (stepIndex === 1 && this.answer.usageScenario) ||
            (stepIndex === 2 && this.answer.watchStyle)) {
          stepLogPromise = this.getStepDwellTime();
        }
      }
      
      if (this.currentStep < this.totalSteps - 1) {
        this.fakeLoading(async () => {
          this.currentStep++;
          await this.scrollToStep(this.currentStep);
        }, stepLogPromise);
      } else {
        this.fakeLoading(async () => {
          await this.scrollToStep(this.currentStep, true);
        }, stepLogPromise);
      }
    },

    // 通用步骤悬停处理（桌面端）
    handleStepHover(stepNumber, index) {
      this.activeSliderIndex[`step${stepNumber}`] = index;
      const swiperInstance = this.swiperInstances[`step${stepNumber}`];
      if (swiperInstance) {
        swiperInstance.slideTo(index, 500);
      }
    },

    // 通用步骤点击处理
    handleStepClick(stepNumber, value) {
      const stepIndex = stepNumber - 1;
      const step = this.stepsInfo[stepIndex];

      // 根据步骤索引设置答案
      if (stepIndex === 0) {
        this.answer.gender = value;
        this.selectedOptions = [value];
      } else if (stepIndex === 1) {
        this.answer.usageScenario = value;
        this.selectedOptions = [value];
      } else if (stepIndex === 2) {
        this.answer.watchStyle = value;
        this.selectedOptions = [value];
      } else if (stepIndex === 3) {
        // 多选步骤
        if (!this.answer.preferredFeature) {
          this.answer.preferredFeature = [];
        }
        const featureIndex = this.answer.preferredFeature.indexOf(value);
        if (featureIndex > -1) {
          this.answer.preferredFeature.splice(featureIndex, 1);
        } else {
          this.answer.preferredFeature.push(value);
        }
        this.selectedOptions = [...this.answer.preferredFeature];
        return; // 多选不自动跳转
      }

      // 判断是否继续或跳转到结果
      if (this.currentStep < this.totalSteps - 1) {
        // 对于单选步骤，将 getStepDwellTime 作为 delayOrPromise 传入
        const stepLogPromise = stepIndex !== 3 ? this.getStepDwellTime() : Promise.resolve();
        this.fakeLoading(async () => {
          this.currentStep++;
          await this.scrollToStep(this.currentStep);
        }, stepLogPromise);
      } else {
        // 对于单选步骤，将 getStepDwellTime 作为 delayOrPromise 传入
        const stepLogPromise = stepIndex !== 3 ? this.getStepDwellTime() : Promise.resolve();
        this.fakeLoading(async () => {
          await this.scrollToStep(this.currentStep, true);
        }, stepLogPromise);
      }
    },

    // 仅记录单选答案，不自动跳转（移动端使用）
    handleStepSelectOnly(stepNumber, value) {
      const stepIndex = stepNumber - 1;
      if (stepIndex === 0) {
        this.answer.gender = value;
      } else if (stepIndex === 1) {
        this.answer.usageScenario = value;
      } else if (stepIndex === 2) {
        this.answer.watchStyle = value;
      }
    },

    // 保留旧方法以兼容（如果需要）
    handleGenderHover(index) {
      this.handleStepHover(1, index);
    },

    handleGenderClick(gender) {
      this.handleStepClick(1, gender);
    },

    handleProductTypeHover(index) {
      this.handleStepHover(2, index);
    },

    handleProductTypeClick(type) {
      this.handleStepClick(2, type);
    },

    handleUseCaseHover(index) {
      this.handleStepHover(3, index);
    },

    handleUseCaseClick(useCase) {
      this.handleStepClick(3, useCase);
    },

    handlePreferenceHover(index) {
      this.handleStepHover(4, index);
    },

    handlePreferenceClick(preference) {
      this.handleStepClick(4, preference);
    },

    // 初始化 Swiper
    initSwiper() {
      // 动态初始化所有步骤的 Swiper
      this.stepsInfo.forEach((step, index) => {
        const stepNumber = index + 1;
        const swiperElement = document.getElementById(`step-${stepNumber}-swiper`);
        const textElement = document.getElementById(`step-${stepNumber}-text`);
        const tooltipElement = document.getElementById(`step-${stepNumber}-tooltip-text`);
        const paginationElement = document.getElementById(`step-${stepNumber}-pagination`);
        const swipeHint = this.$refs.swipeHint;

        if (swiperElement && paginationElement) {
          const swiper = new window.Swiper(swiperElement, {
            speed: 500,
            pagination: {
              el: paginationElement,
              clickable: true,
            },
            on: {
              slideChange: (swiperInstance) => {
                const activeIndex = swiperInstance.activeIndex;
                const activeOption = step.options[activeIndex];

                // 更新答案
                if (index === 0) {
                  this.answer.gender = activeOption.value || activeOption.label;
                } else if (index === 1) {
                  this.answer.usageScenario = activeOption.value || activeOption.label;
                } else if (index === 2) {
                  this.answer.watchStyle = activeOption.value || activeOption.label;
                }

                // 更新移动端文本
                if (textElement && activeOption) {
                  textElement.textContent = activeOption.label;
                }

                // 隐藏 swipe hint（仅第一步）
                if (index === 0 && swipeHint) {
                  swipeHint.style.display = "none";
                }

                // 更新 activeSliderIndex
                this.activeSliderIndex[`step${stepNumber}`] = activeIndex;
              },
            },
          });

          this.swiperInstances[`step${stepNumber}`] = swiper;
        }
      });
    },

    // 初始化桌面端按钮 slider
    initDesktopSlider() {
      setTimeout(() => {
        // 动态获取所有 Swiper 实例（如果还没有初始化）
        this.stepsInfo.forEach((step, index) => {
          const stepNumber = index + 1;
          if (!this.swiperInstances[`step${stepNumber}`]) {
            const swiperElement = document.getElementById(`step-${stepNumber}-swiper`);
            if (swiperElement?.swiper) {
              this.swiperInstances[`step${stepNumber}`] = swiperElement.swiper;
            }
          }
        });
      }, 100);
    },

    // 工具函数
    fakeApi() {
      return new Promise((resolve) => {
        const timeout = Math.random() * 1000 + 1000;
        setTimeout(() => {
          resolve(true);
        }, timeout);
      });
    },

    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    renderResults(result) {
      const matchResults = result.matchResults;
      if (matchResults && matchResults.resultProducts.length > 0) {
        this.matchResult = {
          resultProducts: matchResults.resultProducts || [],
          answerCountsSum: matchResults.answerCountsSum ?? this.answer?.preferredFeature?.length ?? 0,
        };
        this.$nextTick(() => {
          const allSwiperComponents = this.$refs.contentResult.querySelectorAll("swiper-component");
          allSwiperComponents.forEach((swiperComponent) => {
            swiperComponent.rebind();
          });
        });
        return;
      }
      this.matchResult = {
        resultProducts: [],
        answerCountsSum: 0,
      };
    },
  }));

})


